<template lang="pug">
  div(v-cloak)
    v-container(justify-center)
      v-layout(row rwap)
        v-flex(xs12 sm6 offset-sm3 md4 offset-md4)
          p.display-3 Congratulations.
          p This is default dashboard page.
          p
            | You can overwrite this page if you create
            code app/pages/Dashboard/index.vue
            | and overwrite routing in
            code app/routes.js
            | .

</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/common/pages/Dashboard/index.vue